import React from "react";
import styles from "./Styles.module.scss";
import { Box, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import ScrollToTopLink from "components/ScrollToTopLink/ScrollToTopLink";

const image1 = require("../../../../images/batCategory.jpg");
const image2 = require("../../../../images/glovesCategory.jpg");
const image3 = require("../../../../images/padCategory.jpg");
const image4 = require("../../../../images/shoesCategory.jpg");

const Categories = () => {
  return (
    <div className={styles.mainDealsSection}>
      <div className={`container`}>
        {/* <h1 className={`text-center`}>Top Category</h1>
      <p className={`text-center text-danger`}><span>Millat Sports Top Category.</span></p> */}
        <div container className={`py-4 row ${styles.innerMainSection}`}>
          <div className={`col-lg-6 col-md-6 col-sm-12 ${styles.colBox}`}>
            <Link
              to={{ pathname: `/category/Cricket bats` }}
              className={styles.button}
            >
              <div className={`${styles.imageZoomIn}`}>
                <img src={image1} className={styles.image} loading="lazy"/>
              </div>
            </Link>
          </div>
          <div className={`col-lg-6 col-md-6 col-sm-12 ${styles.colBox}`}>
            <Link
              to={{ pathname: `/category/Batting gloves` }}
              className={styles.button}
            >
              <div className={`${styles.imageZoomIn}`}>
                <img src={image2} className={styles.image} loading="lazy"/>
              </div>
            </Link>
          </div>
          <div className={`col-lg-6 col-md-6 col-sm-12 ${styles.colBox}`}>
            <Link
              to={{ pathname: `/category/Batting pads` }}
              className={styles.button}
            >
              <div className={`${styles.imageZoomIn}`}>
                <img src={image3} className={styles.image} loading="lazy"/>
              </div>
            </Link>
          </div>
          <div className={`col-lg-6 col-md-6 col-sm-12 ${styles.colBox}`}>
            <Link
              to={{ pathname: `/category/Shoes` }}
              className={styles.button}
            >
              <div className={`${styles.imageZoomIn}`}>
                <img src={image4} className={styles.image} loading="lazy"/>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
